var map = {
	"./brand.de-CH.json": 1636,
	"./brand.de-DE.json": 1637,
	"./brand.en-CA.json": 1638,
	"./brand.en-GB.json": 1639,
	"./brand.en-IN.json": 1640,
	"./brand.en-ME.json": 1641,
	"./brand.en-US.json": 1642,
	"./brand.es-EM.json": 1643,
	"./brand.es-ES.json": 1644,
	"./brand.fr-BE.json": 1645,
	"./brand.fr-CA.json": 1646,
	"./brand.fr-CH.json": 1647,
	"./brand.nl-BE.json": 1648,
	"./brand.nl-NL.json": 1649,
	"./brand.pl-PL.json": 1650,
	"./brand.pt-BR.json": 1651
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1635;